module.exports = __webpack_public_path__ + "img/rightBox2.4fb04dca.png";